import styled from 'styled-components'
import { useCurrentUser, useImpersonation } from '../context/useCurrentUser'

const ImpersonationWrapper = styled.div`
    width: 100%;
    height: 50px;
    text-align: center;
    background-color: #c324ba;
    color: white;
    font-size: 18px;
    line-height: 50px;
`

export const ImpersonationWarning = () => {
    const impersonator = useImpersonation()
    const user = useCurrentUser()
    if (!impersonator) return null
    return (
        <ImpersonationWrapper>
            Hi {impersonator}, you are viewing {user.me.email}
        </ImpersonationWrapper>
    )
}
